<div #piechartWidget *ngIf="widgetConfig"  class="piechart-widget" [style.height.px]="widgetheight" (keydown.shift)="onShiftDown($event)" (keyup.shift)="onShiftUp($event)" (keydown.alt)="onAltDown($event)" (keyup.alt)="onAltUp($event)" (focusout)="focusOut()" (mousemove)="mouseMove($event);"
    tabindex="1">
    <canvas #graphCanvas id="graphCanvas_{{widgetConfig.Id}}" (click)="graphClick($event)">{{ graphCanvas }}</canvas>
</div>
